// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1Cns_","imageUploader":"EGiftCard_imageUploader__2aZgH"};